import { UserRoleType } from "@/constants/auth";
import type { CurrentUser } from "@/types/general";

const EDUCATION_MANAGER_ROLE_SLUGS = new Set([
  "education-manager",
  "egitim-yonetici",
]);

function normalizeRoleSlug(raw: string): string {
  return raw.trim().toLowerCase().replace(/_/g, "-");
}

function roleMatchesEducationManager(slug: string | undefined): boolean {
  if (!slug?.trim()) return false;
  return EDUCATION_MANAGER_ROLE_SLUGS.has(normalizeRoleSlug(slug));
}

/** Oturum eğitim yöneticisi mi (JWT userType veya rol adı / roles[]) */
export function isEducationManagerSession(
  userType: number | null,
  user: CurrentUser | null,
): boolean {
  if (userType === UserRoleType.EDUCATION_MANAGER) return true;
  if (roleMatchesEducationManager(user?.role)) return true;
  const roles = user?.roles;
  if (Array.isArray(roles)) {
    return roles.some((r) => roleMatchesEducationManager(r?.name));
  }
  return false;
}
